import { __assign, __awaiter, __generator, __rest } from "tslib";
import { call } from './call';
export var openPhoto = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var lastImageList, nextParams, value, images;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                lastImageList = (params === null || params === void 0 ? void 0 : params.images) || [];
                nextParams = { files: lastImageList.map(function (_a) {
                        var path = _a.path;
                        return path;
                    }), limit: (params === null || params === void 0 ? void 0 : params.limit) || 9 };
                return [4 /*yield*/, call('SKNavigation', 'openGallery', nextParams)];
            case 1:
                value = _a.sent();
                images = value.files.map(function (path) {
                    var image = lastImageList.find(function (image) { return image.path === path; });
                    if (image) {
                        return image;
                    }
                    else {
                        return {
                            path: path,
                        };
                    }
                });
                if (value.code === 0) {
                    return [2 /*return*/, __assign(__assign({}, value), { images: images })];
                }
                else {
                    return [2 /*return*/, __assign(__assign({}, value), { images: lastImageList })];
                }
                return [2 /*return*/];
        }
    });
}); };
export var uploadPhoto = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var lastImageList, fileImageList, nextParams, value, code, files, rest, resData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                lastImageList = params.images;
                fileImageList = lastImageList.filter(function (image) {
                    return !image.url;
                });
                if (!fileImageList.length)
                    return [2 /*return*/, { code: 0, message: 'ok', images: lastImageList }];
                nextParams = { files: fileImageList.map(function (_a) {
                        var path = _a.path;
                        return path;
                    }) };
                return [4 /*yield*/, call('SKNetwork', 'executeUpload', nextParams)];
            case 1:
                value = _a.sent();
                code = value.code, files = value.files, rest = __rest(value, ["code", "files"]);
                resData = __assign({ code: code, images: [] }, rest);
                if (code === 0) {
                    resData.isCompleted = fileImageList.length === files.length;
                    resData.images = lastImageList.map(function (image) {
                        var file = files.find(function (file) { return file.path === image.path; });
                        return file || image;
                    });
                }
                return [2 /*return*/, resData];
        }
    });
}); };
